/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Branch } from './@api/dto/translation.dto';
import { AnalyticsService } from './@core/utils/analytics.service';
import { SeoService } from './@core/utils/seo.service';
import { BRANCH } from './app.module';

@Component({
  selector: 'ngx-app',
  styleUrls: ['app.component.scss'],
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {

  constructor(
    private analytics: AnalyticsService,
    private seoService: SeoService,
    private titleService: Title) {
  }

  ngOnInit(): void {
    this.analytics.trackPageViews();
    this.seoService.trackCanonicalChanges();

    if (BRANCH == Branch.ONLINE) {
      this.setTitle('Online')
    } else if (BRANCH == Branch.IH) {
      this.setTitle('Internet Home')
    }
  }

  public setTitle(newTitle: string) {
    this.titleService.setTitle(newTitle + ' - Portal')
  }
}
